(function () {
  'use strict';

  
  function updatePromoGridWidths() {
    const promoInners = document.querySelectorAll('.promo-grid__info-inner');

    promoInners.forEach((inner) => {
      const parentWidth = inner.offsetWidth;
      
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      const paddingOffset = 6 * rootFontSize;
      const targetWidth = parentWidth - paddingOffset;

      const top = inner.querySelector('.promo-grid__info-inner-top');
      const bottom = inner.querySelector('.promo-grid__info-inner-bottom');
      const link = inner.querySelector('.promo-grid__info-link');

      if (top) top.style.width = `${targetWidth}px`;
      if (bottom) bottom.style.width = `${targetWidth}px`;
      if (link) link.style.width = `${targetWidth}px`;
    });
  }

  function updateProductGridPositions() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const productItems = productGrid.querySelectorAll('.grid__item, .promo-productlist');

    productItems.forEach((item) => {
      if (getComputedStyle(item).display === 'none') return;

      const rect = item.getBoundingClientRect();
      if (Math.round(rect.left) === 0) {
        item.classList.add('text-padding-left');
      } else {
        item.classList.remove('text-padding-left');
      }
    });
  }

  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateProductGridPositions();
      updatePromoGridWidths();
    });
  } else {
    updateProductGridPositions();
    updatePromoGridWidths();
  }

  
  document.addEventListener('shopify:section:load', updateProductGridPositions);

  
  document.addEventListener('product-grid:products-loaded', updateProductGridPositions);

  
  document.addEventListener('product-grid:updated', updateProductGridPositions);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateProductGridPositions();
      updatePromoGridWidths();
    }, 100);
  });

  
  document.addEventListener('shopify:section:load', updatePromoGridWidths);
  document.addEventListener('product-grid:products-loaded', updatePromoGridWidths);
  document.addEventListener('product-grid:updated', updatePromoGridWidths);
})();
